import React, { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { DataTable, SubHeading } from "../../Components";
import {
  API_ADD_MATCH,
  API_GET_GETALLCHANNELS,
  API_RESTART,
} from "../../utils/api/ApiConstant";
import {
  getAxios,
  postAxios,
  postLiveFeedUrlAxios,
} from "../../Services/commonService";
import Icon from "../../assets/icons/Icon";
import { CommonModal, ConfimationModal, LiveTvModal } from "../../Modal";

const LiveTv = () => {
  const { pagePermission } = useSelector((state) => state.user);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const { isLoading, data: livetvData } = useQuery({
    queryKey: ["livetvData", isShow.apiFlag],
    queryFn: async () => await getAxios(API_GET_GETALLCHANNELS),
  });

  const handleDelete = async ({ rowData }) => {
    const res = await postAxios(`${API_ADD_MATCH}/deleteChannel`, rowData);
    if (res) {
      setIsShow((prev) => ({
        ...prev,
        apiFlag: !prev.apiFlag,
      }));
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "channelName",
        header: "channel name",
      },
      {
        accessorKey: "channelUrl",
        header: "channel url",
      },
      {
        accessorKey: "isActive",
        header: "action",
        cell: ({ row }) => (
          <div className="action_icon_box">
            <Icon
              name="FaEdit"
              className="btn btn-outline-secondary icon_button"
              cursorPointer={true}
              onClick={() => {
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: true,
                  rowData: row?.original,
                  name: "edit",
                  modalTitle: "Edit Live Tv",
                  modalContent: LiveTvModal,
                }));
              }}
            />
            <ConfimationModal
              isIcon={true}
              iconName="FaTrash"
              getValue={() => {}}
              onStatusChange={() => handleDelete({ rowData: row?.original })}
            />
          </div>
        ),
      },
    ],
    []
  );

  const fetchData = () => {
    if (!livetvData) return { data: [], pages: 0 };

    return {
      data: livetvData,
      pages: livetvData.pages,
    };
  };

  const handlePostRequest = async () => {
    const res = postLiveFeedUrlAxios({ url: API_RESTART, payload: {} });
    console.log("🚀 ~ handlePostRequest ~ res:", res);
  };

  return (
    <>
      <SubHeading
        subTitle="live tv list"
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: true,
            rowData: {},
            name: "add",
            modalTitle: "Add live tv",
            modalContent: LiveTvModal,
          }))
        }
        createAccess={pagePermission?.createAccess}
        isRestartService={true}
        onClick={handlePostRequest}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          fetchData={fetchData}
          isLoading={isLoading}
          isSearchable={false}
          isPagination={false}
          isPageSize={false}
        />
      </div>

      <CommonModal
        isShow={isShow.isOpen}
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: false,
            rowData: {},
            name: "",
          }))
        }
        modalTitle={isShow.modalTitle}
      >
        {isShow.modalContent &&
          React.createElement(isShow.modalContent, {
            handleShowHide: () =>
              setIsShow((prev) => ({
                ...prev,
                isOpen: false,
                rowData: {},
                name: "",
                modalTitle: "",
                apiFlag: !prev.apiFlag,
              })),
            rowData: isShow.rowData,
          })}
      </CommonModal>
    </>
  );
};

export default LiveTv;
